<template>
  <div class="custom-table-responsive table-responsive">
    <table class="table table-bordered table table-journals not-last-td">
      <thead>
        <tr class="cusmtom-thead-color">
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label fixed-column-custom-th"
          >
            <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content">
                <span>{{ $t('labor.cpa_capture_tooltip') }}</span>
              </div>
              <em class="fa fa-info-circle" aria-hidden="true"></em>
            </el-tooltip>
            <br />
            <span>{{ $t('common_words.specific_area') }}</span>
          </th>
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label fixed-column-unit-th"
          >
            {{ $t('common_words.unit') }} *
          </th>
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label fixed-column-activity-th"
          >
            {{ $t('common_words.activity') }} *
          </th>
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label fixed-column-lot-th"
          >
            {{ $t('common_words.allotment') }} *
          </th>
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label fixed-column-covered-area-th"
          >
            {{ $t('common_words.value') }}
          </th>
          <th
            scope="col"
            :colspan="weekList.length"
            class="text-center p-3 custom-header-label"
          >
            {{ $t('common_words.week') }}
          </th>
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label"
          >
            <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content">
                <span>{{ $t('common_words.cpa_setting_tooltip') }}</span>
              </div>
              <em class="fa fa-info-circle" aria-hidden="true"></em>
            </el-tooltip>
            <br />
            {{ $t('common_words.setting2') }}
          </th>
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label"
          >
            <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content">
                <span>{{ $t('common_words.weekly_qty_tooltip') }}</span>
              </div>
              <em class="fa fa-info-circle" aria-hidden="true"></em>
            </el-tooltip>
            <br />
            {{ $t('common_words.weekly_control') }}
          </th>
          <th
            scope="col"
            rowspan="2"
            class="text-center p-3 custom-header-label fixed-column-operations-th"
          >
            {{ $t('common_words.actions') }}
          </th>
        </tr>
        <tr class="cusmtom-thead-color">
          <th
            v-for="week in weekList"
            :key="week"
            scope="col"
            class="text-center p-3 custom-header-label"
          >
            {{ week }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(_, index) in form.nCatchs" :key="index">
          <td
            class="text-center fixed-column-custom-td"
            style="min-width: 110px"
          >
            <el-checkbox
              v-model="form.custom[index]"
              :disabled="!isHectareUnit(index) || isFarmCatchType(index)"
              @change="handleCustomSelection(index)"
            ></el-checkbox>
          </td>
          <td class="text-center fixed-column-unit-td" style="min-width: 180px">
            <select-component
              :key="`unit-${index}-${form.unit[index] || 'empty'}`"
              :dataOptions="activityUnits"
              :initialSelection="form.unit[index]"
              :isMultiple="false"
              :indexSelect="index"
              :requireClass="'required-unit'"
              @onChange="handleInputChange"
              @onClear="handleUnitClear(index)"
              modelName="unit"
            />
          </td>
          <td
            class="text-center fixed-column-activity-td"
            style="min-width: 250px"
          >
            <select-component
              :key="`activity-${index}-${form.unit[index] || 'empty'}`"
              :dataOptions="filteredActivities(index)"
              :initialSelection="form.activity[index]"
              :isMultiple="false"
              :indexSelect="index"
              :requireClass="'required-activity'"
              @onChange="handleInputChange"
              modelName="activity"
            />
          </td>
          <td class="text-center fixed-column-lot-td" style="min-width: 200px">
            <select-component
              :key="`lot-${index}-${form.custom[index]}-${
                form.unit[index] || 'empty'
              }`"
              :dataOptions="farmLotsMultiple"
              :isMultiple="true"
              :initialSelection="form.lot[index]"
              :indexSelect="index"
              :disabled="isFarmCatchType(index)"
              :requireClass="`required-lot_${index}`"
              @onChange="handleInputChange"
              modelName="lot"
            />
          </td>
          <td
            class="text-center fixed-column-covered-area-td"
            style="min-width: 150px"
          >
            <fg-input
              v-if="isFarmCatchType(index)"
              type="number"
              step="0.01"
              min="0"
              class="mx-3"
              :value="getFarmQuantity(index)"
              @input="setFarmQuantity(index, $event)"
            />
            <el-button
              v-else-if="
                form.unit[index] &&
                (!isHectareUnit(index) || form.custom[index])
              "
              type="info"
              size="mini"
              :disabled="!hasSelectedLots(index)"
              @click="
                form.special_weekly_quantities[index]
                  ? openWeeklyQuantityModal(index)
                  : openQuantityModal(index)
              "
            >
              {{
                isHectareUnit(index)
                  ? $t('common_words.hectare')
                  : $t('common_words.quantity')
              }}
            </el-button>
            <fg-input
              v-else
              type="number"
              step="0.1"
              class="mx-3"
              v-model.number="form.covered_area[index]"
              :disabled="isCoveredAreaDisabled(index)"
              :name="`common_words.area_total_ha_${index}`"
              v-validate="modelValidations.area(index)"
              :error="
                getFieldErrorByIndex('common_words.area_total_ha', true, index)
              "
            />
          </td>
          <td
            v-for="(week, indexcolumn) in weekList"
            :key="indexcolumn"
            class="text-center"
            style="min-width: 100px"
          >
            <el-checkbox
              :value="form.weeks[index] && form.weeks[index].includes(week)"
              :disabled="isPastWeekDisabled(week)"
              @change="handleWeekSelection(index, week)"
            ></el-checkbox>
          </td>
          <td class="text-center" style="min-width: 100px">
            <el-checkbox
              :value="!!form.execution_weeks[index]"
              @change="openExecutionModal(index)"
            ></el-checkbox>
          </td>
          <td class="text-center" style="min-width: 110px">
            <el-checkbox
              :value="!!form.special_weekly_quantities[index]"
              :disabled="!canUseWeeklyQuantities(index)"
              @change="handleSpecialWeeklyQuantities(index)"
            ></el-checkbox>
          </td>
          <td
            class="text-center fixed-column-operations-td"
            style="min-width: 110px"
          >
            <div class="d-flex justify-content-center mt-3">
              <a
                v-if="form.weeks[index] && form.weeks[index].length > 0"
                v-tooltip.top-center="$t('common_words.clear_checks')"
                class="btn-warning btn-simple btn-link custom-margin-actions"
                @click="clearWeekSelection(index)"
              >
                <em class="fa fa-history custom-size-fa-actions"></em>
              </a>
              <a
                v-tooltip.top-center="$t('common_words.edit')"
                class="btn-success btn-simple btn-link custom-margin-actions"
                @click="addScheduleRow()"
              >
                <em class="fa fa-plus custom-size-fa-actions"></em>
              </a>
              <a
                v-if="form.nCatchs > 1"
                v-tooltip.top-center="$t('common_words.erase')"
                class="btn-danger btn-simple btn-link custom-margin-actions"
                @click="removeRow(index)"
              >
                <em class="fa fa-times custom-size-fa-actions"></em>
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <el-dialog
      :title="$t('common_words.quantity_lot')"
      :visible.sync="quantityModal.visible"
      width="20%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div
        v-for="lot in selectedLotsForModal"
        :key="lot.id"
        class="quantity-row"
      >
        <label>{{ lot.name }}</label>
        <fg-input
          type="number"
          step="0.01"
          min="0"
          v-model.number="quantityModal.values[lot.id]"
        />
      </div>

      <div class="text-right mt-2">
        <span class="dialog-footer">
          <button
            class="btn btn-danger custom-shadow-btn"
            @click="quantityModal.visible = false"
          >
            {{ $t('common_words.cancel') }}</button
          >&nbsp;
          <button
            class="btn custom-btn-success custom-shadow-btn"
            @click="saveQuantityModal"
          >
            {{ $t('common_words.confirm') }}
          </button>
        </span>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('common_words.weekly_quantity_by_lot')"
      :visible.sync="weeklyQuantityModal.visible"
      width="80%"
      top="3%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="custom-table-responsive table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr class="cusmtom-thead-color">
              <th
                class="text-center p-3 custom-header-label fixed-column-custom-th"
                style="min-width: 80px"
              >
                {{ $t('common_words.allotment') }}
              </th>
              <th
                v-for="week in selectedWeeksForWeeklyModal"
                :key="week"
                class="text-center p-3 custom-header-label"
                :style="'min-width:100px'"
              >
                {{ week }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="lot in selectedLotsForWeeklyModal" :key="lot.id">
              <td class="text-center fixed-column-custom-td">{{ lot.name }}</td>
              <td
                v-for="week in selectedWeeksForWeeklyModal"
                :key="`${lot.id}-${week}`"
                class="text-center"
              >
                <fg-input
                  type="number"
                  step="0.01"
                  min="0"
                  v-model.number="weeklyQuantityModal.values[week][lot.id]"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-right mt-2">
        <span class="dialog-footer">
          <button
            class="btn btn-danger custom-shadow-btn"
            @click="cancelWeeklyQuantityModal"
          >
            {{ $t('common_words.cancel') }}</button
          >&nbsp;
          <button
            class="btn custom-btn-success custom-shadow-btn"
            @click="saveWeeklyQuantityModal"
          >
            {{ $t('common_words.confirm') }}
          </button>
        </span>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('common_words.settings')"
      :visible.sync="executionModal.visible"
      width="320px"
    >
      <select-component
        :dataOptions="executionWeekOptions"
        :initialSelection="executionModal.value"
        :isMultiple="false"
        :labelSelect="$t('common_words.execution_week')"
        modelName="execution_week"
        @onChange="handleExecutionWeekChange"
      />
      <select-component
        v-if="!isHectareUnit(executionModal.index)"
        class="mt-3"
        :dataOptions="executionSourceOptions"
        :initialSelection="executionModal.source"
        :isMultiple="false"
        :labelSelect="$t('common_words.data_source')"
        modelName="execution_source"
        @onChange="handleExecutionSourceChange"
      />

      <div class="text-right mt-2">
        <span class="dialog-footer">
          <button
            class="btn btn-danger custom-shadow-btn"
            @click="clearExecutionWeek"
          >
            {{ $t('common_words.clear') }}</button
          >&nbsp;
          <button
            class="btn custom-btn-success custom-shadow-btn"
            @click="saveExecutionWeek"
          >
            {{ $t('common_words.confirm') }}
          </button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MixinForm from 'src/mixins/forms/mixin-form';
import SweetAlert from 'src/class/Alerts';

export default {
  name: 'ScheduleTable',
  props: {
    form: Object,
    weekList: Array,
    activities: Array,
    activityUnits: Array,
    farmLots: Array,
    farmLotsMultiple: Array,
    isPastWeekDisabled: Function,
    isCoveredAreaDisabled: Function,
  },
  mixins: [MixinForm],
  computed: {
    executionWeekOptions() {
      return [1, 2, 3, 4].map((value) => ({
        id: value,
        name: value.toString(),
      }));
    },
    executionSourceOptions() {
      return [
        {
          id: 'pockets',
          name: 'Embolse',
        },
      ];
    },
    selectedLotsForModal() {
      if (this.quantityModal.index === null) return [];
      const selectedLots = this.getSelectedLotIds(this.quantityModal.index);

      return this.farmLots.filter((lot) => selectedLots.includes(lot.id));
    },
    selectedLotsForWeeklyModal() {
      if (this.weeklyQuantityModal.index === null) return [];
      const selectedLots = this.getSelectedLotIds(
        this.weeklyQuantityModal.index
      );

      return this.farmLots.filter((lot) => selectedLots.includes(lot.id));
    },
    selectedWeeksForWeeklyModal() {
      if (this.weeklyQuantityModal.index === null) return [];

      return this.form.weeks[this.weeklyQuantityModal.index] || [];
    },
    getMaxArea() {
      return (index) => {
        const lotId = this.form.lot[index];
        if (!lotId) return null;

        const lot = this.farmLots.find((l) => l.id === lotId);

        return lot ? Number(lot.area) : null;
      };
    },
  },
  data() {
    return {
      quantityModal: {
        visible: false,
        index: null,
        values: {},
      },
      weeklyQuantityModal: {
        visible: false,
        index: null,
        values: {},
      },
      executionModal: {
        visible: false,
        index: null,
        value: null,
        source: null,
      },
      modelValidations: {
        area: (index) => ({
          required: this.form.custom[index],
          max: 6,
          min_value: 0,
          max_value: this.getMaxArea(index),
          decimal: 2,
        }),
      },
    };
  },
  methods: {
    getActivityUnitId(activity) {
      return (
        activity.activity_unit_payment_id ||
        activity.unit_payment_id ||
        (activity.activity_unit_payment
          ? activity.activity_unit_payment.id
          : null)
      );
    },
    filteredActivities(index) {
      const unitId = this.form.unit[index];
      if (!unitId) return [];

      return this.activities.filter(
        (activity) => this.getActivityUnitId(activity) === unitId
      );
    },
    getSelectedActivity(index) {
      return this.activities.find(
        (activity) => activity.id === this.form.activity[index]
      );
    },
    isFarmCatchType(index) {
      const activity = this.getSelectedActivity(index);
      const catchType =
        activity && activity.catch_type
          ? activity.catch_type.toString().toLowerCase()
          : '';

      return catchType === 'finca';
    },
    isHectareUnit(index) {
      const unit = this.activityUnits.find(
        (item) => item.id === this.form.unit[index]
      );
      const name = unit && unit.name ? unit.name.toString().toLowerCase() : '';

      const abbreviation =
        unit && unit.abbreviation
          ? unit.abbreviation.toString().toLowerCase()
          : '';

      return name === 'hectarea' || abbreviation === 'ha';
    },
    getSelectedLotIds(index) {
      const lotValue = this.form.lot[index];
      if (!lotValue) return [];

      return Array.isArray(lotValue)
        ? lotValue.filter((id) => id !== 0)
        : [lotValue];
    },
    hasSelectedLots(index) {
      if (this.isFarmCatchType(index)) return true;

      return this.getSelectedLotIds(index).length > 0;
    },
    canUseWeeklyQuantities(index) {
      return (
        this.form.unit[index] &&
        !this.isFarmCatchType(index) &&
        (!this.isHectareUnit(index) || this.form.custom[index]) &&
        this.hasSelectedLots(index) &&
        this.form.weeks[index] &&
        this.form.weeks[index].length > 0
      );
    },
    openQuantityModal(index) {
      const currentValues = this.form.lot_quantities[index] || {};
      this.quantityModal.index = index;
      this.quantityModal.values = { ...currentValues };
      this.quantityModal.visible = true;
    },
    saveQuantityModal() {
      this.$set(this.form.lot_quantities, this.quantityModal.index, {
        ...this.quantityModal.values,
      });
      this.quantityModal.visible = false;
    },
    getFarmQuantity(index) {
      const quantities = this.form.lot_quantities[index] || {};

      return quantities[0];
    },
    setFarmQuantity(index, value) {
      const quantities = {
        ...(this.form.lot_quantities[index] || {}),
        0: value,
      };

      this.$set(this.form.lot_quantities, index, quantities);
    },
    buildWeeklyQuantityValues(index) {
      const currentValues = this.form.weekly_lot_quantities[index] || {};
      const values = {};

      (this.form.weeks[index] || []).forEach((week) => {
        values[week] = {};
        this.getSelectedLotIds(index).forEach((lotId) => {
          values[week][lotId] =
            currentValues[week] && currentValues[week][lotId] !== undefined
              ? currentValues[week][lotId]
              : null;
        });
      });

      return values;
    },
    handleSpecialWeeklyQuantities(index) {
      const value = !this.form.special_weekly_quantities[index];

      if (value) {
        this.$set(this.form.special_weekly_quantities, index, true);
        this.$set(this.form.lot_quantities, index, {});
        this.openWeeklyQuantityModal(index);
      } else {
        SweetAlert.confirm(
          this.$t('common_words.confirm'),
          this.$t('common_words.quantities_recorded_modal_cleared')
        ).then((result) => {
          if (result.value) {
            this.$set(this.form.special_weekly_quantities, index, false);
            this.$set(this.form.weekly_lot_quantities, index, {});
          }
        });
      }
    },
    openWeeklyQuantityModal(index) {
      this.weeklyQuantityModal.index = index;
      this.weeklyQuantityModal.values = this.buildWeeklyQuantityValues(index);
      this.weeklyQuantityModal.visible = true;
    },
    cancelWeeklyQuantityModal() {
      this.weeklyQuantityModal.visible = false;
    },
    saveWeeklyQuantityModal() {
      this.$set(
        this.form.weekly_lot_quantities,
        this.weeklyQuantityModal.index,
        { ...this.weeklyQuantityModal.values }
      );
      this.weeklyQuantityModal.visible = false;
    },
    openExecutionModal(index) {
      this.executionModal.index = index;
      this.executionModal.value = this.form.execution_weeks[index] || null;
      this.executionModal.source = this.form.execution_sources[index] || null;

      this.executionModal.source = this.isHectareUnit(index)
        ? null
        : this.form.execution_sources[index] || null;

      this.executionModal.visible = true;
    },
    handleExecutionWeekChange(data) {
      this.executionModal.value = data.selects;
    },
    handleExecutionSourceChange(data) {
      this.executionModal.source = data.selects;
    },
    clearExecutionWeek() {
      this.$set(this.form.execution_weeks, this.executionModal.index, null);
      this.$set(this.form.execution_sources, this.executionModal.index, null);
      this.executionModal.visible = false;
    },
    saveExecutionWeek() {
      this.$set(
        this.form.execution_weeks,
        this.executionModal.index,
        this.executionModal.value
      );
      this.$set(
        this.form.execution_sources,
        this.executionModal.index,
        this.executionModal.value &&
          !this.isHectareUnit(this.executionModal.index)
          ? this.executionModal.source
          : null
      );
      this.executionModal.visible = false;
    },
    handleInputChange(data) {
      this.$emit('input-change', data);
    },
    handleUnitClear(index) {
      this.$emit('input-change', {
        name: 'unit',
        selects: null,
        index,
      });
    },
    handleWeekSelection(index, week) {
      this.$emit('week-selection-change', index, week);
    },
    handleCustomSelection(index) {
      this.$emit('custom-selection-change', index);
    },
    clearWeekSelection(index) {
      this.$emit('clear-week-selection', index);
    },
    addScheduleRow() {
      this.$emit('add-row');
    },
    removeRow(index) {
      this.$emit('remove-row', index);
    },
  },
};
</script>

<style scoped>
.fixed-column-custom-th,
.fixed-column-unit-th,
.fixed-column-activity-th,
.fixed-column-lot-th,
.fixed-column-covered-area-th,
.fixed-column-execution-th,
.fixed-column-operations-th,
.fixed-column-custom-td,
.fixed-column-unit-td,
.fixed-column-activity-td,
.fixed-column-lot-td,
.fixed-column-covered-area-td,
.fixed-column-execution-td,
.fixed-column-operations-td {
  position: sticky;
  border-right: 1px solid;
  z-index: 3;
}

.fixed-column-custom-th,
.fixed-column-unit-th,
.fixed-column-activity-th,
.fixed-column-lot-th,
.fixed-column-covered-area-th,
.fixed-column-execution-th,
.fixed-column-operations-th {
  background-color: #898989;
}

.fixed-column-custom-td,
.fixed-column-unit-td,
.fixed-column-activity-td,
.fixed-column-lot-td,
.fixed-column-covered-area-td,
.fixed-column-execution-td,
.fixed-column-operations-td {
  background-color: #fff;
}

.fixed-column-custom-th,
.fixed-column-custom-td {
  left: 0;
}

.fixed-column-unit-th,
.fixed-column-unit-td {
  left: 110px;
  z-index: 2;
}

.fixed-column-execution-th,
.fixed-column-execution-td {
  right: 110px;
  z-index: 2;
}

.quantity-row {
  margin-bottom: 12px;
  background-color: #fff;
}

.fixed-column-activity-th,
.fixed-column-activity-td {
  left: 110px;
  z-index: 2;
}

.fixed-column-lot-th,
.fixed-column-lot-td {
  left: 360px;
  z-index: 2;
}

.fixed-column-covered-area-th,
.fixed-column-covered-area-td {
  left: 560px;
  z-index: 2;
}

.fixed-column-operations-th,
.fixed-column-operations-td {
  right: 0;
  z-index: 2;
}
</style>
